var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 359,
    viewBox: "0 0 349 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 229,
    cy: 130,
    r: 229,
    fill: "#FC5027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundShape);
export default __webpack_public_path__ + "static/media/roundShape.937b0e22415c37d81779ce535056a1ae.svg";
export { ForwardRef as ReactComponent };